{"regionLabel":"言語の提案","message":"このページは日本語でもご利用いただけます。","cta":"日本語で見る","dismiss":"閉じる"}